module.exports = __webpack_public_path__ + "static/media/Area 1.bd85c89c.png";